


export interface DefaultVatRateOption {
    value: string;
    label: string;
    percentage: number;
}

export const DEFAULT_VAT_RATE_PERCENTAGE_CODE = 'VAT_21';
export const DEFAULT_VAT_RATE_PERCENTAGE = 2100;


export const DEFAULT_VAT_RATE_OPTIONS = [
    {value: 'VAT_21', label: '21%', percentage: 2100},
    {value: 'VAT_9', label: '9%', percentage: 900},
    {value: 'VAT_0', label: '0%', percentage: 0},
    {value: 'VAT_NONE', label: 'Geen BTW', percentage: 0},
];



